import React from "react";
import { X } from "lucide-react";

// Convierte una URL de YouTube/Vimeo a su formato embed. Devuelve null si no es reconocida.
function toEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\.|^m\./, "");
    if (host === "youtube.com" || host === "youtube-nocookie.com") {
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;
      const parts = u.pathname.split("/").filter(Boolean);
      if (parts[0] === "embed" && parts[1]) return `https://www.youtube.com/embed/${parts[1]}`;
      if (parts[0] === "shorts" && parts[1]) return `https://www.youtube.com/embed/${parts[1]}`;
    }
    if (host === "youtu.be") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id) return `https://www.youtube.com/embed/${id}`;
    }
    if (host === "vimeo.com" || host === "player.vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean).pop();
      if (id && /^\d+$/.test(id)) return `https://player.vimeo.com/video/${id}`;
    }
  } catch (_) {
    return null;
  }
  return null;
}

// Reproductor interno reutilizable (ProgramaCard y CatalogoPilar). Nunca abre pestaña externa.
export function VideoModal({ open, onClose, fileUrl, externalUrl, title }) {
  if (!open) return null;
  const embed = externalUrl ? toEmbed(externalUrl) : null;
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/75 backdrop-blur-sm p-4"
      data-testid="video-modal"
      onClick={onClose}
    >
      <div className="w-full max-w-3xl bg-slate-900 rounded-2xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <p className="text-white font-semibold text-sm truncate">{title || "Video"}</p>
          <button onClick={onClose} data-testid="video-modal-close" className="text-white/60 hover:text-white transition-colors">
            <X size={18} />
          </button>
        </div>
        {fileUrl ? (
          <video src={fileUrl} controls autoPlay className="w-full aspect-video bg-black" data-testid="video-modal-file" />
        ) : embed ? (
          <iframe
            src={embed}
            title={title || "Video"}
            className="w-full aspect-video bg-black"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="video-modal-embed"
          />
        ) : externalUrl ? (
          <video src={externalUrl} controls autoPlay className="w-full aspect-video bg-black" data-testid="video-modal-file" />
        ) : (
          <div className="p-10 text-center text-white/60 text-sm">Sin video disponible.</div>
        )}
      </div>
    </div>
  );
}

export default VideoModal;
